import * as mixins from './mixins';
import * as vars from './vars';
import media from './media';
import * as fonts from './fonts';

const cssKit = { vars, mixins, media, fonts };

export default cssKit;



/** WEBPACK FOOTER **
 ** ./src/css/index.js
 **/